<template>
  <div>
    <div class="wp_FilterAccordian">
      <div
        class="accordion position-relative"
        :id="'wp_accordion'+filters.filName"
        @click.prevent="filterToggler()"
								data-test="filterAccordionFilterName"
      >
        {{filters.filterName}}

        <div class="wp_downArrowFilter">
          <svg
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            class="wp_ArrowAccordion"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="451.847px"
            height="451.847px"
            viewBox="0 0 451.847 451.847"
            style="enable-background:new 0 0 451.847 451.847;"
            xml:space="preserve"
												data-test="filterAccordionFilterSvg"
          >
            <g>
              <path d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,
              151.157c-12.359-12.359-12.359-32.397,0-44.751 c12.354-12.354,
                32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,
                32.391-12.354,44.744,0
                c12.365,12.354,12.365,32.392,0,44.751L248.292,
                345.449C242.115,351.621,234.018,354.706,225.923,354.706z">
              </path>
            </g>
          </svg>
        </div>
      </div>
      <div
        class="panel wp_checkBoxes"
        :id="'wp_accordion_panel'+filters.filName"
      >
        <ol class="list-unstyled">
          <li
            v-for="(fil, index) in filters.filterValues"
            :key=fil+filters.filName
          >
            <label
              class="wp_CheckContainer"
              :for=fil+filter.filterName+index
              :id="'filter-checkbox-label-'+filter.filterName+index"
														:data-test="'filterAccordionFilterValue'+index"
            >
              {{fil}}{{(filters.filterName === 'ratings')?'★':''}}
              <input
                type="checkbox"
                :id=fil+filter.filterName+index
                :value=fil
                :name="fil"
                v-model="selectedFilters"
                @change="applyFilter()"
                checked="false"
																:data-test="'filterAccordionFilterCheckBox'+index"
              >
              <span class="checkmark"></span>
            </label>
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import eventService from '../../../../../../services/DomEventServices/domEventServices'

export default {
	name: 'filter-accordion',
	props: {
		filter: Object
	},
	beforeMount () {
		this.selectedFilters = []
		this.filters = this.filter
		this.filters.filName = this.filter.filterName.replace(/\s/g, '')
	},
	mounted () {
		this.$root.$on('clearAllFilter', () => {
			this.selectedFilters = []
			this.filters = this.filter
			this.filters.filName = this.filter.filterName.replace(/\s/g, '')
		})
	},
	data () {
		return {
			selectedFilters: [],
			filters: {}
		}
	},
	computed: {
		...mapGetters('filters', ['getFilters'])
	},
	methods: {
		...mapActions('filters', ['updateFilterApplied']),
		filterToggler () {
			// let panel = document.getElementById('wp_accordion_panel'+this.filters.filName);
			// // let acc = document.getElementById('wp_accordion'+this.filters.filName);
			// // acc.classList.toggle("active");
			// if (panel.style.display === "block") {
			//       panel.style.display = "none";
			//     } else {
			//       panel.style.display = "block";
			//     }
			eventService.accordionToggler(`wp_accordion_panel${this.filters.filName}`)
		},
		applyFilter () {
			document.body.scrollTop = 0
			document.documentElement.scrollTop = 0
			const filterData = {
				activeFilters: this.selectedFilters,
				filterName: this.filter.filterName
			}
			this.$emit('filterChange', filterData)
		}
	},
	watch: {
		$route: {
			handler (val) {
				this.selectedFilters = []
				this.filters = this.filter
				this.filters.filName = this.filter.filterName.replace(/\s/g, '')
			},
			deep: true
		},
		filter: {
			handler (val) {
				this.selectedFilters = []
				this.filters = this.filter
				this.filters.filName = this.filter.filterName.replace(/\s/g, '')
			},
			deep: true
		}
		// selectedFilters: {
		//   handler(val) {
		//     if (this.selectedFilters.length > 0) {
		//       this.updateFilterApplied(true);
		//     } else {
		//       this.updateFilterApplied(false);
		//     }
		//   },
		//   deep: true,
		// },
	}
}
</script>
